import { render, staticRenderFns } from "./vertical-ranking-stress.vue?vue&type=template&id=317d20f8&"
import script from "./vertical-ranking-stress.vue?vue&type=script&lang=js&"
export * from "./vertical-ranking-stress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports